export const PolygonIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '26'}
      height={props.height ? props.height : '29'}
      {...props}
      viewBox="0 0 26 29"
      fill="none"
    >
      <path d="M13.5 0.5L20.8612 13.25H6.13878L13.5 0.5Z" fill="#5B5B5B" />
      <rect x="14" y="16.5" width="12" height="12" fill="#5B5B5B" />
      <rect y="16.5" width="12" height="12" rx="6" fill="#5B5B5B" />
    </svg>
  );
};

export const RightArrow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '25'}
      height={props.height ? props.height : '25'}
      viewBox="0 0 25 25"
      fill="none"
      {...props}
      // widths={50}
    >
      <path
        d="M9.26953 5.5L16.2695 12.5L9.26953 19.5"
        stroke="#5B5B5B"
        stroke-width="2"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const HoneIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '16'}
      height={props.height ? props.height : '18'}
      viewBox="0 0 16 18"
      fill="none"
      {...props}
    >
      <path
        d="M14.8093 6.93049L8.58707 1.41799C8.25194 1.12109 7.75153 1.12109 7.4164 1.41799L1.19418 6.93049C1.00127 7.10139 0.890625 7.34829 0.890625 7.60781V15.2994C0.890625 15.7965 1.28859 16.1994 1.77951 16.1994H5.33507C5.82599 16.1994 6.22396 15.7965 6.22396 15.2994V11.6994C6.22396 11.2024 6.62193 10.7994 7.11285 10.7994H8.89062C9.38155 10.7994 9.77951 11.2024 9.77951 11.6994V15.2994C9.77951 15.7965 10.1775 16.1994 10.6684 16.1994H14.224C14.7149 16.1994 15.1128 15.7965 15.1128 15.2994V7.60781C15.1128 7.34829 15.0022 7.10139 14.8093 6.93049Z"
        fill="#5B5B5B"
      />
    </svg>
  );
};

export const InfoFilledIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '15'}
      height={props.height ? props.height : '16'}
      viewBox="0 0 15 16"
      fill="none"
      {...props}
    >
      <path
        d="M7.5 14.25C10.9518 14.25 13.75 11.4518 13.75 8C13.75 4.54822 10.9518 1.75 7.5 1.75C4.04822 1.75 1.25 4.54822 1.25 8C1.25 11.4518 4.04822 14.25 7.5 14.25Z"
        fill="#5B5B5B"
      />
      <path
        d="M13 8C13 11.0376 10.5376 13.5 7.5 13.5V15C11.366 15 14.5 11.866 14.5 8H13ZM7.5 13.5C4.46243 13.5 2 11.0376 2 8H0.5C0.5 11.866 3.63401 15 7.5 15V13.5ZM2 8C2 4.96243 4.46243 2.5 7.5 2.5V1C3.63401 1 0.5 4.13401 0.5 8H2ZM7.5 2.5C10.5376 2.5 13 4.96243 13 8H14.5C14.5 4.13401 11.366 1 7.5 1V2.5Z"
        fill="#5B5B5B"
      />
      <path
        d="M7.24458 9.39889V9.33843C7.24908 8.94384 7.29076 8.62987 7.36961 8.39651C7.45071 8.16315 7.56561 7.97434 7.7143 7.83008C7.86299 7.68582 8.04209 7.55429 8.2516 7.43549C8.38678 7.35487 8.50843 7.26471 8.61657 7.165C8.7247 7.06529 8.81031 6.95074 8.87339 6.82133C8.93647 6.69192 8.96801 6.54872 8.96801 6.39173C8.96801 6.20292 8.9207 6.03957 8.82608 5.90168C8.73146 5.76378 8.6053 5.65771 8.4476 5.58346C8.29216 5.50709 8.11869 5.4689 7.92719 5.4689C7.75372 5.4689 7.58814 5.50284 7.43044 5.57073C7.27274 5.63862 7.14207 5.74469 7.03844 5.88895C6.93481 6.03109 6.87511 6.21459 6.85934 6.43947H5.83203C5.8478 6.0576 5.95031 5.73514 6.13955 5.47208C6.32879 5.2069 6.57885 5.00642 6.88975 4.87065C7.2029 4.73488 7.54871 4.66699 7.92719 4.66699C8.34172 4.66699 8.70443 4.74018 9.01532 4.88656C9.32622 5.03082 9.56728 5.23342 9.73849 5.49436C9.91196 5.75318 9.9987 6.05548 9.9987 6.40128C9.9987 6.63888 9.95927 6.85315 9.88042 7.04408C9.80157 7.23289 9.68893 7.40154 9.54249 7.55005C9.39831 7.69855 9.22484 7.83008 9.02208 7.94464C8.83059 8.05707 8.67514 8.17375 8.55574 8.29468C8.43859 8.4156 8.35298 8.5588 8.29891 8.72427C8.24485 8.88974 8.21556 9.09446 8.21105 9.33843V9.39889H7.24458ZM7.75485 11.3337C7.57011 11.3337 7.41129 11.2721 7.27837 11.1491C7.14545 11.0239 7.07899 10.8733 7.07899 10.6972C7.07899 10.5233 7.14545 10.3748 7.27837 10.2517C7.41129 10.1266 7.57011 10.064 7.75485 10.064C7.93733 10.064 8.09503 10.1266 8.22795 10.2517C8.36312 10.3748 8.43071 10.5233 8.43071 10.6972C8.43071 10.8139 8.39917 10.921 8.33609 11.0186C8.27526 11.1141 8.19416 11.1905 8.09278 11.2477C7.9914 11.305 7.87876 11.3337 7.75485 11.3337Z"
        fill="white"
      />
    </svg>
  );
};
export const InfoLinedIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '15'}
      height={props.height ? props.height : '15'}
      viewBox="0 0 15 15"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_17112_50905)">
        <path
          d="M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z"
          stroke="#5B5B5B"
          stroke-width="1.5"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 6.80566V10.2779"
          stroke="#5B5B5B"
          stroke-width="1.5"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.46484 4.72266H7.53429V4.7921H7.46484V4.72266Z"
          stroke="#5B5B5B"
          stroke-width="1.5"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_17112_50905">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '19'}
      height={props.height ? props.height : '12'}
      viewBox="0 0 19 12"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.491027 0.527208C1.14573 -0.175736 2.20721 -0.175736 2.86191 0.527208L9.5 7.65442L16.1381 0.527208C16.7928 -0.175736 17.8543 -0.175736 18.509 0.527208C19.1637 1.23015 19.1637 2.36985 18.509 3.07279L10.6854 11.4728C10.0307 12.1757 8.96926 12.1757 8.31456 11.4728L0.491027 3.07279C-0.163676 2.36985 -0.163676 1.23015 0.491027 0.527208Z"
        fill="#697386"
      />
    </svg>
  );
};

export const SaperateLine = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '18'}
      height={props.height ? props.height : '3'}
      viewBox="0 0 18 3"
      fill="none"
      {...props}
    >
      <line y1="1.5" x2="18" y2="1.5" stroke="#575757" stroke-width="2" />
    </svg>
  );
};

export const MoreAudience = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : '200'}
      height={props.height ? props.height : '200'}
      viewBox="0 0 200 200"
      fill="none"
      {...props}
    >
      <path
        d="M130.125 67.6035C141.102 67.6035 150 58.7052 150 47.7285C150 36.7519 141.102 27.8535 130.125 27.8535C119.148 27.8535 110.25 36.7519 110.25 47.7285C110.25 58.7052 119.148 67.6035 130.125 67.6035Z"
        fill="#9E3727"
      />
      <path
        d="M160.25 82.9469C160.25 81.9586 159.878 81.0047 159.204 80.2816C151.943 72.4863 141.594 67.6035 130.125 67.6035C118.656 67.6035 108.307 72.4863 101.046 80.2816C100.373 81.0058 99.999 81.9582 100 82.9469V127.829C100 131.064 102.623 133.688 105.859 133.688H154.391C157.627 133.688 160.25 131.064 160.25 127.829V82.9469Z"
        fill="#BFE04B"
      />
      <path
        d="M130.125 27.8535C141.084 27.8535 150 36.7695 150 47.7285C150 58.6875 141.084 67.6035 130.125 67.6035V27.8535Z"
        fill="#730D06"
      />
      <path
        d="M154.39 133.688C157.626 133.688 160.25 131.064 160.25 127.829L160.25 82.9469C160.25 81.9586 159.878 81.0047 159.204 80.2816C151.943 72.4863 141.594 67.6035 130.125 67.6035V133.688H154.39V133.688Z"
        fill="#67D360"
      />
      <path
        d="M69.875 67.6035C80.8517 67.6035 89.75 58.7052 89.75 47.7285C89.75 36.7519 80.8517 27.8535 69.875 27.8535C58.8983 27.8535 50 36.7519 50 47.7285C50 58.7052 58.8983 67.6035 69.875 67.6035Z"
        fill="#FAA17B"
      />
      <path
        d="M100 82.9469C100 81.9586 99.6277 81.0047 98.9543 80.2816C91.6926 72.4863 81.3438 67.6035 69.875 67.6035C58.4062 67.6035 48.0574 72.4863 40.7957 80.2816C40.1226 81.0058 39.749 81.9582 39.75 82.9469V127.829C39.75 131.064 42.3734 133.688 45.6094 133.688H94.1402C97.3762 133.688 99.9996 131.064 99.9996 127.829L100 82.9469Z"
        fill="#00EDEE"
      />
      <path
        d="M69.875 27.8535C80.834 27.8535 89.75 36.7695 89.75 47.7285C89.75 58.6875 80.834 67.6035 69.875 67.6035V27.8535Z"
        fill="#EF8564"
      />
      <path
        d="M94.1402 133.688C97.3762 133.688 99.9996 131.064 99.9996 127.829L100 82.9469C100 81.9586 99.6277 81.0047 98.9543 80.2816C91.6926 72.4863 81.3438 67.6035 69.875 67.6035V133.688H94.1402V133.688Z"
        fill="#00C1E8"
      />
      <path
        d="M39.75 119.842C50.7267 119.842 59.625 110.943 59.625 99.9668C59.625 88.9901 50.7267 80.0918 39.75 80.0918C28.7733 80.0918 19.875 88.9901 19.875 99.9668C19.875 110.943 28.7733 119.842 39.75 119.842Z"
        fill="#C96148"
      />
      <path
        d="M60.25 172.144C67.6453 172.144 79.4996 170.713 79.4996 159.592C79.4996 137.674 61.668 119.842 39.7496 119.842C17.8313 119.842 0 137.674 0 159.592V166.285C0 169.521 2.62344 172.145 5.85938 172.145H60.25V172.144Z"
        fill="#FFE835"
      />
      <path
        d="M39.75 80.0918C50.709 80.0918 59.625 89.0078 59.625 99.9668C59.625 110.926 50.709 119.842 39.75 119.842V80.0918Z"
        fill="#9E3727"
      />
      <path
        d="M160.246 119.842C171.223 119.842 180.121 110.943 180.121 99.9668C180.121 88.9901 171.223 80.0918 160.246 80.0918C149.269 80.0918 140.371 88.9901 140.371 99.9668C140.371 110.943 149.269 119.842 160.246 119.842Z"
        fill="#FED2C2"
      />
      <path
        d="M160.25 80.0918C171.209 80.0918 180.125 89.0078 180.125 99.9668C180.125 110.926 171.209 119.842 160.25 119.842V80.0918Z"
        fill="#FBB0A8"
      />
      <path
        d="M100 119.842C110.977 119.842 119.875 110.943 119.875 99.9668C119.875 88.9901 110.977 80.0918 100 80.0918C89.0233 80.0918 80.125 88.9901 80.125 99.9668C80.125 110.943 89.0233 119.842 100 119.842Z"
        fill="#FDC584"
      />
      <path
        d="M100 80.0918C110.959 80.0918 119.875 89.0078 119.875 99.9668C119.875 110.926 110.959 119.842 100 119.842V80.0918Z"
        fill="#F8A671"
      />
      <path
        d="M60.2504 172.144C67.6457 172.144 79.5 170.713 79.5 159.592C79.5 137.674 61.6684 119.842 39.75 119.842V172.144H60.2504Z"
        fill="#FFC833"
      />
      <path
        d="M139.746 172.144C132.35 172.144 120.496 170.713 120.496 159.592C120.496 137.674 138.328 119.842 160.246 119.842C182.164 119.842 199.996 137.674 199.996 159.592V166.285C199.996 169.521 197.372 172.145 194.136 172.145H139.746V172.144Z"
        fill="#5699FB"
      />
      <path
        d="M139.715 172.144H59.6289V159.592C59.6289 137.674 77.5922 119.842 99.6719 119.842C121.752 119.842 139.715 137.673 139.715 159.592V172.144Z"
        fill="#FF6F64"
      />
      <path
        d="M139.75 172.144V159.592C139.75 137.674 121.918 119.842 100 119.842V172.144H139.75Z"
        fill="#FF2776"
      />
      <path
        d="M160.25 119.842C182.168 119.842 200 137.673 200 159.592V166.285C200 169.521 197.377 172.144 194.141 172.144H160.25V119.842Z"
        fill="#4465F2"
      />
    </svg>
  );
};

export const MoreResult = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200px"
      height="200px"
      viewBox="0 0 200 200"
      fill="none"
    >
      <g clip-path="url(#clip0_17402_75271)">
        <path
          d="M41.406 141.404H17.9687C14.7328 141.404 12.1094 144.028 12.1094 147.264V190.232C12.1094 193.468 14.7328 196.091 17.9687 196.091H41.406C44.6419 196.091 47.2654 193.468 47.2654 190.232V147.264C47.2654 144.028 44.6419 141.404 41.406 141.404ZM88.2807 127.342H64.8433C61.6074 127.342 58.984 129.965 58.984 133.201V190.232C58.984 193.468 61.6074 196.091 64.8433 196.091H88.2807C91.5166 196.091 94.14 193.468 94.14 190.232V133.201C94.14 129.965 91.5166 127.342 88.2807 127.342Z"
          fill="#4BC0FF"
        />
        <path
          d="M135.156 105.859H111.719C108.483 105.859 105.859 108.482 105.859 111.718V190.233C105.859 193.469 108.483 196.093 111.719 196.093H135.156C138.392 196.093 141.015 193.469 141.015 190.233V111.718C141.015 108.482 138.392 105.859 135.156 105.859ZM182.031 66.7969H158.593C155.357 66.7969 152.734 69.4203 152.734 72.6562V190.233C152.734 193.469 155.357 196.093 158.593 196.093H182.031C185.267 196.093 187.89 193.469 187.89 190.233V72.6562C187.89 69.4203 185.267 66.7969 182.031 66.7969Z"
          fill="#0592FD"
        />
        <path
          d="M199.799 40.1512L190.204 4.34288C189.802 2.84188 188.82 1.56214 187.474 0.785128C186.128 0.00811883 184.529 -0.202517 183.028 0.199552L147.22 9.7944C144.093 10.6319 142.239 13.8448 143.076 16.9705C143.914 20.0963 147.128 21.9517 150.252 21.1135L173.321 14.9322C159.913 38.2317 137.754 61.1795 110.982 79.1946C77.4564 101.755 40.1227 114.18 5.85933 114.18C2.62342 114.18 0 116.804 0 120.04C0 123.276 2.62342 125.899 5.85933 125.899C42.4286 125.899 82.0857 112.765 117.525 88.9176C145.281 70.24 168.417 46.3797 182.789 21.9474L188.479 43.1844C189.181 45.8023 191.548 47.5289 194.135 47.5289C194.649 47.5285 195.16 47.4609 195.656 47.3277C198.781 46.4898 200.636 43.277 199.799 40.1512Z"
          fill="#A5D02A"
        />
        <path
          d="M199.8 40.1512L190.205 4.34288C189.803 2.84188 188.821 1.56214 187.475 0.785128C186.129 0.00811883 184.53 -0.202517 183.029 0.199552L147.221 9.7944C144.095 10.6319 142.24 13.8448 143.077 16.9705C143.915 20.0963 147.129 21.9517 150.254 21.1135L173.322 14.9322C159.914 38.2317 137.755 61.1795 110.983 79.1946C107.388 81.6113 103.726 83.9259 100 86.1356V99.6484C105.993 96.3237 111.84 92.7433 117.526 88.9172C145.282 70.2396 168.418 46.3793 182.79 21.947L188.48 43.184C189.182 45.8019 191.549 47.5285 194.136 47.5285C194.649 47.5281 195.16 47.4605 195.656 47.3273C198.782 46.4898 200.638 43.277 199.8 40.1512Z"
          fill="#90BC02"
        />
        <path
          d="M194.139 199.998H5.85933C2.62342 199.998 0 197.375 0 194.139C0 190.903 2.62342 188.279 5.85933 188.279H194.139C197.375 188.279 199.998 190.903 199.998 194.139C199.998 197.375 197.375 199.998 194.139 199.998Z"
          fill="#466288"
        />
        <path
          d="M194.14 188.279H100V199.998H194.14C197.376 199.998 199.999 197.375 199.999 194.139C199.999 190.903 197.376 188.279 194.14 188.279Z"
          fill="#354A67"
        />
      </g>
      <defs>
        <clipPath id="clip0_17402_75271">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MoreAccurately = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
    >
      <path
        d="M130.289 100.002C130.289 94.0131 128.513 88.1588 125.186 83.1793C121.859 78.1998 117.13 74.3188 111.597 72.027C106.064 69.7352 99.9761 69.1356 94.1024 70.3039C88.2287 71.4723 82.8333 74.3561 78.5986 78.5908C74.364 82.8255 71.4801 88.2209 70.3117 94.0946C69.1434 99.9682 69.743 106.056 72.0348 111.589C74.3266 117.122 78.2077 121.851 83.1871 125.178C88.1666 128.506 94.0209 130.282 100.01 130.282C108.035 130.263 115.726 127.067 121.4 121.392C127.075 115.718 130.271 108.027 130.289 100.002ZM102.632 124.897V115.841C102.632 115.145 102.356 114.478 101.864 113.987C101.372 113.495 100.705 113.219 100.01 113.219C99.3141 113.219 98.6471 113.495 98.1553 113.987C97.6636 114.478 97.3873 115.145 97.3873 115.841V124.897C91.6881 124.29 86.369 121.748 82.3162 117.695C78.2635 113.642 75.7218 108.323 75.1145 102.624H84.1705C84.866 102.624 85.533 102.348 86.0248 101.856C86.5166 101.364 86.7929 100.697 86.7929 100.002C86.7929 99.3063 86.5166 98.6393 86.0248 98.1475C85.533 97.6557 84.866 97.3795 84.1705 97.3795H75.1145C75.7218 91.6803 78.2635 86.3612 82.3162 82.3084C86.369 78.2557 91.6881 75.714 97.3873 75.1067V84.1627C97.3873 84.8582 97.6636 85.5252 98.1553 86.017C98.6471 86.5088 99.3141 86.785 100.01 86.785C100.705 86.785 101.372 86.5088 101.864 86.017C102.356 85.5252 102.632 84.8582 102.632 84.1627V75.1067C108.331 75.714 113.65 78.2557 117.703 82.3084C121.756 86.3612 124.298 91.6803 124.905 97.3795H115.849C115.153 97.3795 114.486 97.6557 113.994 98.1475C113.503 98.6393 113.226 99.3063 113.226 100.002C113.226 100.697 113.503 101.364 113.994 101.856C114.486 102.348 115.153 102.624 115.849 102.624H124.905C124.298 108.323 121.756 113.642 117.703 117.695C113.65 121.748 108.331 124.29 102.632 124.897ZM102.632 168.498V173.953C121.331 173.268 139.079 165.533 152.31 152.302C165.541 139.071 173.276 121.323 173.961 102.624H168.506C167.825 119.877 160.666 136.239 148.456 148.449C136.247 160.658 119.885 167.817 102.632 168.498ZM31.5131 102.624H26.0586C26.7437 121.323 34.4785 139.071 47.7096 152.302C60.9408 165.533 78.6882 173.268 97.3873 173.953V168.498C80.1343 167.817 63.772 160.658 51.5628 148.449C39.3536 136.239 32.1946 119.877 31.5131 102.624ZM97.3873 31.5053V26.0508C78.6882 26.7358 60.9408 34.4707 47.7096 47.7018C34.4785 60.933 26.7437 78.6804 26.0586 97.3795H31.5131C32.1946 80.1265 39.3536 63.7642 51.5628 51.555C63.772 39.3458 80.1343 32.1868 97.3873 31.5053ZM102.632 26.0508V31.5053C119.885 32.1868 136.247 39.3458 148.456 51.555C160.666 63.7642 167.825 80.1265 168.506 97.3795H173.961C173.276 78.6804 165.541 60.933 152.31 47.7018C139.079 34.4707 121.331 26.7358 102.632 26.0508Z"
        fill="#0FBCF9"
      />
      <path
        d="M162.937 0H37.0629C27.2389 0.0184836 17.8225 3.92925 10.8759 10.8759C3.92925 17.8225 0.0184836 27.2389 0 37.0629V162.937C0.0184836 172.761 3.92925 182.177 10.8759 189.124C17.8225 196.071 27.2389 199.982 37.0629 200H162.937C172.761 199.982 182.177 196.071 189.124 189.124C196.071 182.177 199.982 172.761 200 162.937V37.0629C199.982 27.2389 196.071 17.8225 189.124 10.8759C182.177 3.92925 172.761 0.0184836 162.937 0ZM187.413 102.622H179.266C178.569 122.728 170.271 141.82 156.046 156.046C141.82 170.271 122.728 178.569 102.622 179.266V187.413C102.622 188.108 102.346 188.775 101.854 189.267C101.363 189.759 100.696 190.035 100 190.035C99.3045 190.035 98.6375 189.759 98.1457 189.267C97.6539 188.775 97.3776 188.108 97.3776 187.413V179.266C77.2721 178.569 58.1795 170.271 43.9543 156.046C29.729 141.82 21.4306 122.728 20.7343 102.622H12.5874C11.8919 102.622 11.2249 102.346 10.7331 101.854C10.2413 101.363 9.96503 100.696 9.96503 100C9.96503 99.3045 10.2413 98.6375 10.7331 98.1457C11.2249 97.6539 11.8919 97.3776 12.5874 97.3776H20.7343C21.4306 77.2721 29.729 58.1795 43.9543 43.9543C58.1795 29.729 77.2721 21.4306 97.3776 20.7343V12.5874C97.3776 11.8919 97.6539 11.2249 98.1457 10.7331C98.6375 10.2413 99.3045 9.96503 100 9.96503C100.696 9.96503 101.363 10.2413 101.854 10.7331C102.346 11.2249 102.622 11.8919 102.622 12.5874V20.7343C122.728 21.4306 141.82 29.729 156.046 43.9543C170.271 58.1795 178.569 77.2721 179.266 97.3776H187.413C188.108 97.3776 188.775 97.6539 189.267 98.1457C189.759 98.6375 190.035 99.3045 190.035 100C190.035 100.696 189.759 101.363 189.267 101.854C188.775 102.346 188.108 102.622 187.413 102.622Z"
        fill="#0FBCF9"
      />
    </svg>)
}

export const CreateCampaignIcon = (props) => {
  return (
    <svg width={props.width ?? '18'}
    height={props.height ?? '14'} viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9974 7.83301V6.16634H17.3307V7.83301H13.9974ZM14.9974 13.6663L12.3307 11.6663L13.3307 10.333L15.9974 12.333L14.9974 13.6663ZM13.3307 3.66634L12.3307 2.33301L14.9974 0.333008L15.9974 1.66634L13.3307 3.66634ZM3.16406 12.833V9.49968H2.33073C1.8724 9.49968 1.48003 9.33648 1.15365 9.01009C0.827257 8.6837 0.664062 8.29134 0.664062 7.83301V6.16634C0.664062 5.70801 0.827257 5.31565 1.15365 4.98926C1.48003 4.66287 1.8724 4.49967 2.33073 4.49967H5.66406L9.83073 1.99967V11.9997L5.66406 9.49968H4.83073V12.833H3.16406ZM10.6641 9.79134V4.20801C11.0391 4.54134 11.3411 4.94759 11.5703 5.42676C11.7995 5.90593 11.9141 6.43023 11.9141 6.99968C11.9141 7.56912 11.7995 8.09343 11.5703 8.57259C11.3411 9.05176 11.0391 9.45801 10.6641 9.79134Z" fill={props.color ?? 'white'}/>
</svg>

  );
};

export const ObjectiveAdformat = (props) => {
  return (
    <svg width={props.width ?? '18'}
    height={props.height ?? '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.66797 14.0003C5.20964 14.0003 4.81727 13.8371 4.49089 13.5107C4.1645 13.1844 4.0013 12.792 4.0013 12.3337V2.33366C4.0013 1.87533 4.1645 1.48296 4.49089 1.15658C4.81727 0.830187 5.20964 0.666992 5.66797 0.666992H15.668C16.1263 0.666992 16.5187 0.830187 16.8451 1.15658C17.1714 1.48296 17.3346 1.87533 17.3346 2.33366V12.3337C17.3346 12.792 17.1714 13.1844 16.8451 13.5107C16.5187 13.8371 16.1263 14.0003 15.668 14.0003H5.66797ZM5.66797 4.00033H15.668V2.33366H5.66797V4.00033ZM2.33464 17.3337C1.8763 17.3337 1.48394 17.1705 1.15755 16.8441C0.831163 16.5177 0.667969 16.1253 0.667969 15.667V4.00033H2.33464V15.667H14.0013V17.3337H2.33464Z" fill={props.color ?? 'white'}/>
</svg>

  );
};

export const AudienceIcon = (props) => {
  return (
    <svg width={props.width ?? '20'}
    height={props.height ?? '14'} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.832031 13.6663V10.333C0.832031 9.86079 0.995226 9.46495 1.32161 9.14551C1.648 8.82606 2.04036 8.66634 2.4987 8.66634H5.22786C5.50564 8.66634 5.76953 8.73579 6.01953 8.87467C6.26953 9.01356 6.47092 9.20106 6.6237 9.43717C7.02648 9.97884 7.523 10.4025 8.11328 10.708C8.70356 11.0136 9.33203 11.1663 9.9987 11.1663C10.6793 11.1663 11.3147 11.0136 11.9049 10.708C12.4952 10.4025 12.9848 9.97884 13.3737 9.43717C13.5543 9.20106 13.7661 9.01356 14.0091 8.87467C14.2522 8.73579 14.5056 8.66634 14.7695 8.66634H17.4987C17.9709 8.66634 18.3668 8.82606 18.6862 9.14551C19.0056 9.46495 19.1654 9.86079 19.1654 10.333V13.6663H13.332V11.7705C12.8459 12.1177 12.3216 12.3816 11.7591 12.5622C11.1966 12.7427 10.6098 12.833 9.9987 12.833C9.40148 12.833 8.81814 12.7393 8.2487 12.5518C7.67925 12.3643 7.15148 12.0969 6.66536 11.7497V13.6663H0.832031ZM9.9987 10.333C9.47092 10.333 8.97092 10.2115 8.4987 9.96842C8.02648 9.72537 7.63064 9.38856 7.3112 8.95801C7.07509 8.61079 6.77995 8.33648 6.42578 8.13509C6.07161 7.9337 5.6862 7.83301 5.26953 7.83301C5.57509 7.31912 6.22092 6.91287 7.20703 6.61426C8.19314 6.31565 9.1237 6.16634 9.9987 6.16634C10.8737 6.16634 11.8043 6.31565 12.7904 6.61426C13.7765 6.91287 14.4223 7.31912 14.7279 7.83301C14.3251 7.83301 13.9431 7.9337 13.582 8.13509C13.2209 8.33648 12.9223 8.61079 12.6862 8.95801C12.3806 9.40245 11.9918 9.74273 11.5195 9.97884C11.0473 10.215 10.5404 10.333 9.9987 10.333ZM3.33203 7.83301C2.63759 7.83301 2.04731 7.58995 1.5612 7.10384C1.07509 6.61773 0.832031 6.02745 0.832031 5.33301C0.832031 4.62467 1.07509 4.03092 1.5612 3.55176C2.04731 3.07259 2.63759 2.83301 3.33203 2.83301C4.04036 2.83301 4.63411 3.07259 5.11328 3.55176C5.59245 4.03092 5.83203 4.62467 5.83203 5.33301C5.83203 6.02745 5.59245 6.61773 5.11328 7.10384C4.63411 7.58995 4.04036 7.83301 3.33203 7.83301ZM16.6654 7.83301C15.9709 7.83301 15.3806 7.58995 14.8945 7.10384C14.4084 6.61773 14.1654 6.02745 14.1654 5.33301C14.1654 4.62467 14.4084 4.03092 14.8945 3.55176C15.3806 3.07259 15.9709 2.83301 16.6654 2.83301C17.3737 2.83301 17.9674 3.07259 18.4466 3.55176C18.9258 4.03092 19.1654 4.62467 19.1654 5.33301C19.1654 6.02745 18.9258 6.61773 18.4466 7.10384C17.9674 7.58995 17.3737 7.83301 16.6654 7.83301ZM9.9987 5.33301C9.30425 5.33301 8.71398 5.08995 8.22786 4.60384C7.74175 4.11773 7.4987 3.52745 7.4987 2.83301C7.4987 2.12467 7.74175 1.53092 8.22786 1.05176C8.71398 0.572591 9.30425 0.333008 9.9987 0.333008C10.707 0.333008 11.3008 0.572591 11.7799 1.05176C12.2591 1.53092 12.4987 2.12467 12.4987 2.83301C12.4987 3.52745 12.2591 4.11773 11.7799 4.60384C11.3008 5.08995 10.707 5.33301 9.9987 5.33301Z" fill={props.color ?? 'white'} />
</svg>

  );
};

export const BudgetScheduleIcon = (props) => {
  return (
    <svg width={props.width ?? '18'}
    height={props.height ?? '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.3958 14.9792L14.9792 14.3958L13.4167 12.8333V10.5H12.5833V13.1667L14.3958 14.9792ZM13 17.1667C11.8472 17.1667 10.8646 16.7604 10.0521 15.9479C9.23958 15.1354 8.83333 14.1528 8.83333 13C8.83333 11.8472 9.23958 10.8646 10.0521 10.0521C10.8646 9.23958 11.8472 8.83333 13 8.83333C14.1528 8.83333 15.1354 9.23958 15.9479 10.0521C16.7604 10.8646 17.1667 11.8472 17.1667 13C17.1667 14.1528 16.7604 15.1354 15.9479 15.9479C15.1354 16.7604 14.1528 17.1667 13 17.1667ZM3.83333 5.5H12.1667V3.83333H3.83333V5.5ZM7.72917 15.5H2.16667C1.70833 15.5 1.31597 15.3368 0.989583 15.0104C0.663194 14.684 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663194 1.31597 0.989583 0.989583C1.31597 0.663194 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.684 0.663194 15.0104 0.989583C15.3368 1.31597 15.5 1.70833 15.5 2.16667V7.75C15.0972 7.55556 14.691 7.40972 14.2812 7.3125C13.8715 7.21528 13.4444 7.16667 13 7.16667C12.8472 7.16667 12.7049 7.17014 12.5729 7.17708C12.441 7.18403 12.3056 7.20139 12.1667 7.22917V7.16667H3.83333V8.83333H8.9375C8.6875 9.06944 8.46181 9.32639 8.26042 9.60417C8.05903 9.88194 7.88194 10.1806 7.72917 10.5H3.83333V12.1667H7.22917C7.20139 12.3056 7.18403 12.441 7.17708 12.5729C7.17014 12.7049 7.16667 12.8472 7.16667 13C7.16667 13.4583 7.20833 13.8854 7.29167 14.2812C7.375 14.6771 7.52083 15.0833 7.72917 15.5Z" fill={props.color ?? 'white'} />
</svg>

  );
};

export const SetupAdsIcon = (props) => {
  return (
<svg width={props.width ?? '14'}
    height={props.height ?? '16'} viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0612 13.625C10.2973 13.1667 10.4779 12.684 10.6029 12.1771C10.7279 11.6701 10.7904 11.1458 10.7904 10.6042C10.7904 9.49306 10.5473 8.47569 10.0612 7.55208C9.57509 6.62847 8.91536 5.86111 8.08203 5.25L6.16536 7.16667V0.5H12.832L10.9154 2.41667C11.6376 3.06944 12.214 3.84722 12.6445 4.75C13.0751 5.65278 13.2904 6.63194 13.2904 7.6875C13.2904 8.95139 12.9952 10.0972 12.4049 11.125C11.8147 12.1528 11.0334 12.9861 10.0612 13.625ZM1.16536 15.5L3.08203 13.5833C2.34592 12.9306 1.76606 12.1528 1.34245 11.25C0.918837 10.3472 0.707031 9.36806 0.707031 8.3125C0.707031 7.04861 1.00217 5.90278 1.59245 4.875C2.18273 3.84722 2.97092 3.01389 3.95703 2.375C3.72092 2.83333 3.53689 3.31597 3.40495 3.82292C3.273 4.32986 3.20703 4.85417 3.20703 5.39583C3.20703 6.50694 3.45356 7.52431 3.94661 8.44792C4.43967 9.37153 5.09592 10.1389 5.91536 10.75L7.83203 8.83333V15.5H1.16536Z" fill={props.color ?? 'white'}/>
</svg>

  );
};
export const ReviewLaunchIcon = (props) => {
  return (
<svg width={props.width ?? '18'}
    height={props.height ?? '18'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.04167 7.81208L4.54167 4.31208C4.73611 4.11764 4.96528 3.97875 5.22917 3.89542C5.49306 3.81208 5.76389 3.79819 6.04167 3.85375L7.125 4.08292C6.375 4.97181 5.78472 5.77736 5.35417 6.49958C4.92361 7.22181 4.50694 8.09681 4.10417 9.12458L1.04167 7.81208ZM5.3125 9.70792C5.63194 8.70792 6.06597 7.76347 6.61458 6.87458C7.16319 5.98569 7.82639 5.15236 8.60417 4.37458C9.82639 3.15236 11.2222 2.23917 12.7917 1.635C14.3611 1.03083 15.8264 0.846805 17.1875 1.08292C17.4236 2.44403 17.2431 3.90931 16.6458 5.47875C16.0486 7.04819 15.1389 8.44403 13.9167 9.66625C13.1528 10.4301 12.3194 11.0933 11.4167 11.6558C10.5139 12.2183 9.5625 12.6593 8.5625 12.9788L5.3125 9.70792ZM11.0625 7.20792C11.3819 7.52736 11.7743 7.68708 12.2396 7.68708C12.7049 7.68708 13.0972 7.52736 13.4167 7.20792C13.7361 6.88847 13.8958 6.49611 13.8958 6.03083C13.8958 5.56556 13.7361 5.17319 13.4167 4.85375C13.0972 4.53431 12.7049 4.37458 12.2396 4.37458C11.7743 4.37458 11.3819 4.53431 11.0625 4.85375C10.7431 5.17319 10.5833 5.56556 10.5833 6.03083C10.5833 6.49611 10.7431 6.88847 11.0625 7.20792ZM10.4792 17.2288L9.14583 14.1663C10.1736 13.7635 11.0521 13.3468 11.7813 12.9163C12.5104 12.4857 13.3194 11.8954 14.2083 11.1454L14.4167 12.2288C14.4722 12.5065 14.4583 12.7808 14.375 13.0517C14.2917 13.3225 14.1528 13.5551 13.9583 13.7496L10.4792 17.2288ZM2.375 12.3746C2.86111 11.8885 3.45139 11.6419 4.14583 11.635C4.84028 11.6281 5.43056 11.8676 5.91667 12.3538C6.40278 12.8399 6.64583 13.4301 6.64583 14.1246C6.64583 14.819 6.40278 15.4093 5.91667 15.8954C5.56944 16.2426 4.98958 16.5413 4.17708 16.7913C3.36458 17.0413 2.24306 17.2635 0.8125 17.4579C1.00694 16.0274 1.22917 14.9093 1.47917 14.1038C1.72917 13.2982 2.02778 12.7218 2.375 12.3746Z" fill={props.color ?? 'white'}/>
</svg>

  );
};
export const CheckCircleRoundedIcon = (props) => {
  return (
<svg width={props.width ?? '15'}
    height={props.height ?? '15'} viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.992" fill-rule="evenodd" clip-rule="evenodd" d="M6.88132 -0.0136719C7.28204 -0.0136719 7.68272 -0.0136719 8.08343 -0.0136719C10.8228 0.329241 12.7762 1.75112 13.9437 4.25195C14.225 4.94058 14.4026 5.65152 14.4765 6.38477C14.4765 6.78582 14.4765 7.18684 14.4765 7.58789C14.1338 10.3295 12.7132 12.2846 10.2144 13.4531C9.5264 13.7347 8.81606 13.9124 8.08343 13.9863C7.68272 13.9863 7.28204 13.9863 6.88132 13.9863C4.14199 13.6434 2.18856 12.2215 1.02103 9.7207C0.739739 9.03208 0.562154 8.32114 0.488281 7.58789C0.488281 7.18684 0.488281 6.78582 0.488281 6.38477C0.830905 3.64312 2.25158 1.68804 4.75031 0.519531C5.43835 0.237998 6.14869 0.0602637 6.88132 -0.0136719ZM10.7609 3.95117C11.3252 3.95541 11.5939 4.23798 11.5668 4.79883C11.5379 4.88409 11.5015 4.96612 11.4575 5.04492C9.9025 6.62867 8.32243 8.1827 6.7174 9.70703C6.46482 9.81364 6.22803 9.7863 6.00706 9.625C5.21476 8.90496 4.42246 8.18489 3.63016 7.46484C3.30237 7.10902 3.30237 6.75355 3.63016 6.39844C3.92757 6.19218 4.21898 6.20132 4.50442 6.42578C5.1328 7.00457 5.76117 7.58332 6.38955 8.16211C7.75067 6.81352 9.10758 5.46 10.4603 4.10156C10.5557 4.03561 10.6559 3.98549 10.7609 3.95117Z" fill={props.color ?? "#3D5A80"} />
</svg>

  );
};
export const AdCampaignDefaultImageIcon = (props) => {
  return (
<svg width={props.width ?? '40'}
    height={props.height ?? '40'} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 32C10.9 32 9.95833 31.6083 9.175 30.825C8.39167 30.0417 8 29.1 8 28V4C8 2.9 8.39167 1.95833 9.175 1.175C9.95833 0.391667 10.9 0 12 0H36C37.1 0 38.0417 0.391667 38.825 1.175C39.6083 1.95833 40 2.9 40 4V28C40 29.1 39.6083 30.0417 38.825 30.825C38.0417 31.6083 37.1 32 36 32H12ZM12 8H36V4H12V8ZM4 40C2.9 40 1.95833 39.6083 1.175 38.825C0.391667 38.0417 0 37.1 0 36V8H4V36H32V40H4Z" fill="#AAAAAA"/>
</svg>

  );
};
